import React from 'react';
import { Customer } from '@/hooks/useCustomers';
import { useSourceManager } from '@/hooks/useSourceManager';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface SMTPSourceCardProps {
  customer: Customer;
  onSetupMode?: (mode: string) => void;
}

export const SMTPSourceCard: React.FC<SMTPSourceCardProps> = ({ customer }) => {
  const { sources, enableSource, disableSource, loading } = useSourceManager(customer.id);
  
  const smtpSource = sources.smtp;
  const isActive = smtpSource?.status === 'active';
  
  const handleToggle = async () => {
    if (isActive) {
      await disableSource('smtp');
    } else {
      await enableSource('smtp', { auto_enabled: true });
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-orange-500/10 rounded-lg flex items-center justify-center">
            <span className="text-xl">📮</span>
          </div>
          <div>
            <h3 className="font-medium">SMTP Email</h3>
            <p className="text-sm text-muted-foreground">Direct email server integration</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Badge variant={isActive ? "default" : "secondary"}>
            {isActive ? "✅ Active" : "⚙️ Setup Required"}
          </Badge>
          <Button size="sm" onClick={handleToggle} disabled={loading}>
            {isActive ? "Disable" : "Enable"}
          </Button>
        </div>
      </div>
    </div>
  );
};